import React, { useEffect, useState } from 'react'
import { CustomDropdownSelector } from '../CustomDropdownSelector'
import { fetchListCustomerGroup } from 'redux/actions/clientsActions'
import { useDispatch } from 'react-redux'

export const DisplayCustomerGroup = ({
  formik,
  customerTypeId,
  customerType,
}) => {
  const [customerGroup, setCustomerGroup] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchGroupClient = async () => {
      try {
        const response = await dispatch(
          fetchListCustomerGroup({
            CustomerGroupId: null,
            SearchText: null,
            PageSize: 20,
            PageNumber: 1,
            customerTypeId,
          })
        )

        if (response?.length) setCustomerGroup(response)
      } catch (error) {
        console.error('fetchGroupClientError ->', error)
      }
    }

    fetchGroupClient()
  }, [customerTypeId])

  // Extraer el valor directamente desde Formik
  const selectedValue =
    customerGroup.find(
      item =>
        item.CustomerGroupId?.toUpperCase() ===
        formik.values.generalGroup?.[0]?.customerGroupId?.toUpperCase()
    ) || null

  return (
    <CustomDropdownSelector
      label="Tipo de cliente*"
      value={selectedValue}
      options={customerGroup}
      onSelect={item => {
        formik.setFieldValue('generalGroup', [
          {
            customerGroupId: item.CustomerGroupId,
            Description: item.Description,
          },
        ])
      }}
      getOptionLabel={item => item.Description}
      getOptionValue={item => item.CustomerGroupId}
      error={
        formik.touched.generalGroup && formik.errors.generalGroup
          ? formik.errors.generalGroup.toString()
          : ''
      }
      name="dropdown-customer-group"
      customerType={customerType}
    />
  )
}
